import { Component, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import * as fromApp from '../../store/app.reducer';

export interface BundleOfferPromptView {
  signature: string;
  offerProduct: any;
  coveredItems: { cart_id: any; label: string; units: number }[];
  offerTotal: string;
  currencySymbol: string;
  showPricesWithComma?: boolean;
}

/** Presentation only: BundleOfferSuggestionService decides whether a
 * suggestion is shown and acts on the answer this modal dismisses with. */
@Component({
  selector: 'app-bundle-offer-prompt',
  templateUrl: './bundle-offer-prompt.component.html',
  styleUrls: ['./bundle-offer-prompt.component.scss'],
})
export class BundleOfferPromptComponent implements OnInit, OnDestroy {
  @Input() view: BundleOfferPromptView;

  public imageUrl: string = null;
  public group: string;
  public iconImage: string;
  public demo = false;
  public showSecondaryMigrationProductIdCatalog = false;
  public answered = false;

  private backSubscription: Subscription;

  constructor(
    private store: Store<fromApp.AppState>,
    private modalController: ModalController,
    @Optional() private platform?: Platform
  ) {}

  ngOnInit() {
    this.backSubscription = this.platform?.backButton.subscribeWithPriority(300, () => {
      if (this.platform.is('android')) this.decline();
    });
    this.store
      .select('groupApp')
      .pipe(first())
      .subscribe((state) => {
        this.group = state?.groupApp?.group;
        this.iconImage = state?.groupApp?.iconImage;
        // Same image source as the recommended product card.
        const image = this.view?.offerProduct?.image?.true?.['16x9'];
        this.imageUrl = image?.path
          ? 'https://images.deliverymanager.gr/' +
            image.path +
            (state?.webp ? '.webp' : image.type || '.jpg')
          : null;
      });

    this.store
      .select('auth')
      .pipe(first())
      .subscribe((state) => {
        this.demo = !!state?.user?.demo;
      });


  }

  ngOnDestroy() {
    this.backSubscription?.unsubscribe();
  }

  accept() {
    this.answer('accept');
  }

  decline() {
    this.answer('dismiss');
  }

  private answer(data: 'accept' | 'dismiss') {
    if (this.answered) {
      return;
    }
    this.answered = true;
    this.modalController.dismiss(data);
  }
}
